import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAwEPNwbhvh_yHBvZizkkm2yVD5CLVsvZM",
  authDomain: "uai-thai.firebaseapp.com",
  projectId: "uai-thai",
  storageBucket: "uai-thai.firebasestorage.app",
  messagingSenderId: "145273358658",
  appId: "1:145273358658:web:9b5b4961a3d6626a80e0db",
  measurementId: "G-ZMWQ90SD3D"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { app, database };